// extracted by mini-css-extract-plugin
export default {"root":"SubsidyFeeding_root__3V2lT","title":"SubsidyFeeding_title__M4sgT","icon":"SubsidyFeeding_icon__CzdYW","placeHolderShimmer":"SubsidyFeeding_placeHolderShimmer__bKVhy"};